<form class="agreement-picker" [formGroup]="agreementForm">
  <mat-slide-toggle
    class="agreement-picker__toggler mb-4"
    [checked]="showInactive()"
    (change)="showInactive.set($event.checked)">
    {{ 'ShowInactiveAgreements' | translate }}
  </mat-slide-toggle>

  <mat-form-field appearance="outline" class="agreement-picker__select">
    <mat-label>{{ 'WAD-Agreement' | translate }}</mat-label>
    <mat-select formControlName="agreement" [compareWith]="compareAgreements">
      @for (a of filteredAgreements(); track a.Id) {
      <mat-option [value]="a">
        {{ a.EmploymentType }} | {{ a.Employer }}
        &nbsp;|&nbsp;
        {{ a.EmploymentDateFrom | date: 'yyyy-MM-dd' }}
        &nbsp;–&nbsp;
        @if (a.AgreementTerminationEndDate) {
        {{ a.AgreementTerminationEndDate | date: 'yyyy-MM-dd' }}
        } @else if (a.EmploymentDateTo) {
        {{ a.EmploymentDateTo | date: 'yyyy-MM-dd' }}
        } @else {
        {{ 'UndefinedTerm' | translate }}
        }
      </mat-option>
      }
    </mat-select>
  </mat-form-field>
</form>